import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { TokenStorageService } from '../services/token-storage.service';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
  constructor(private tokenStorage: TokenStorageService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    const expectedGroups = next.data['groups'] as string[];
    const rawUser = this.tokenStorage.getUser();
    const user = rawUser && rawUser.user ? rawUser.user : rawUser;
    const userGroups: string[] = user?.groups || [];
    console.log('[RoleGuard] expectedGroups:', expectedGroups, 'userGroups:', userGroups);
    if (user && expectedGroups && expectedGroups.some(g => userGroups.includes(g))) {
      console.log('[RoleGuard] Access granted');
      return true;
    } else {
      console.warn('[RoleGuard] Access denied, redirecting to /loggin');
      return this.router.createUrlTree(['/loggin']);
    }
  }
}
